export default __webpack_public_path__ + "static/media/ligajabar-logo.ffdccc60.png";